import type { FC } from 'react';
import type { TGlobalCompensationDetailsProps } from '@components/Organisms/GlobalCompensation/GlobalCompensation.types';
import { useTranslation } from 'react-i18next';
import { GlobalCompensationDetailsItem } from '@components/Organisms/GlobalCompensation/_partials/GlobalCompensationDetailsItem';
import { DETAILS_ITEMS_TYPES } from '@components/Organisms/GlobalCompensation/_constants/bonuses-and-benefits.constants';
import { GlobalCompensationBonuses } from '@components/Organisms/GlobalCompensation/_partials/GlobalCompensationBonuses';

export const GlobalCompensationDetails: FC<TGlobalCompensationDetailsProps> = ({
  annualSalary,
  benefits,
  bonuses,
}) => {
  const { t } = useTranslation('', {
    keyPrefix: 'globalCompensation.compensationPackage',
  });

  const annualSalaryContent = annualSalary ? annualSalary.toString() : '-';

  return (
    <div className="c-global-compensation__details">
      <div className="c-global-compensation__details-header">
        <p className="c-global-compensation__heading">{t('details.title')}</p>
      </div>

      <ul className="c-global-compensation__details-list">
        <GlobalCompensationDetailsItem
          itemType={DETAILS_ITEMS_TYPES.RAL}
          value={annualSalaryContent}
        />

        <GlobalCompensationBonuses
          annualSalary={annualSalary}
          bonuses={bonuses}
        />

        {benefits.map(benefit => (
          <GlobalCompensationDetailsItem
            details={benefit.details}
            itemType={benefit.type}
            key={benefit.type}
            value={benefit.value}
          />
        ))}
      </ul>
    </div>
  );
};
